import Page from '../page';
import ScrollMagic from 'scrollmagic';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';

export default class HomepageIndex extends Page {
	constructor(...args) {
		super(...args);

		this._retrieveDOM();
		this._initTls();
	}

	_retrieveDOM() {
		super._retrieveDOM();

		this.dom.strat1 = this.dom.page.querySelector('.strat-1');
		this.dom.strat1bg = this.dom.page.querySelector('.strat-1 .ct--background-grid');
		this.dom.crossBanner = this.dom.page.querySelector('.js-svg-warning');
		this.dom.bannerWarning = this.dom.page.querySelector('.js-container-warning');
		// this.dom.blockAnim = this.dom.page.querySelectorAll('.ct--reference-card, .ct--news-card');
	}

	init() {
		super.init();
		this.controller = new ScrollMagic.Controller({globalSceneOptions: {reverse: false}});
		new ScrollMagic.Scene({triggerElement: this.dom.strat1})
			.setClassToggle(this.dom.strat1, "active") // add class toggle
			// .addIndicators() // add indicators (requires plugin)
			.addTo(this.controller);
		new ScrollMagic.Scene({triggerElement: this.dom.strat1})
			.setClassToggle(this.dom.strat1bg, "anim-cols") // add class toggle
			// .addIndicators() // add indicators (requires plugin)
			.addTo(this.controller);

		/* for (let i = 0; i < this.dom.blockAnim.length; i++) {
			let el = this.dom.blockAnim[i];

			var tween = new TimelineMax ()
				.add([
					TweenMax.fromTo(el, 2, {y: 150}, {y: 0, delay: (i * 0.1), ease: Power3.easeOut})
				]);

			// build scene
			new ScrollMagic.Scene({triggerElement: el, triggerHook: 'onEnter', offset: -200})
				.setTween(tween)
				// .addIndicators() // add indicators (requires plugin)
				.addTo(this.controller);
		} */
	}

	bind() {
		if (sessionStorage.getItem("closewarning")) {
			this.dom.bannerWarning.classList.toggle('hide');
		}
		if (this.dom.crossBanner) {
			this.dom.crossBanner.addEventListener('click', ()=> {
				this.closeBannerWarning();
			});
		}
	}

	closeBannerWarning() {
		this.dom.bannerWarning.classList.toggle('hide');
		sessionStorage.setItem("closewarning", true);
	}

	/**
	 * init() {}
	 * bind() {}
	 * unbind() {}
	 * resize(width, height) {}
	 * _destroy() {}
	 */
}



// WEBPACK FOOTER //
// ./src/js/pages/homepage/homepage-index.js